export const annualBillingMessage = `billed annually. Save {discountPercentage}% over monthly billing.`
export const monthlyBillingMessage = `billed monthly (save {discountPercentage}% with annual billing).`
